import { render } from "./BreadcrumbSide.vue?vue&type=template&id=740ec170"
import script from "./BreadcrumbSide.vue?vue&type=script&lang=js"
export * from "./BreadcrumbSide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__